import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
var CONTENT_QUERY_KEY = 'content';
var contentKeys = {
  allContent: [CONTENT_QUERY_KEY],
  content: function content(query) {
    return [CONTENT_QUERY_KEY, query];
  },
  contentAutoShareRecipientCount: function contentAutoShareRecipientCount(contentId) {
    var teamIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['all'];
    return [CONTENT_QUERY_KEY, 'auto-share-recipients', contentId, teamIds === null || teamIds === void 0 ? void 0 : teamIds.toString()];
  },
  contentUsersAndTeams: function contentUsersAndTeams(query, playlistIds, assetIds) {
    return [CONTENT_QUERY_KEY, 'users-or-teams', query, playlistIds, assetIds];
  },
  contentLogs: function contentLogs(search) {
    return [CONTENT_QUERY_KEY, 'logs', search];
  },
  mySharedContent: [CONTENT_QUERY_KEY, 'my', 'shared'],
  myFeaturedContent: function myFeaturedContent(limit, offset) {
    return [CONTENT_QUERY_KEY, 'my', 'featured', limit, offset];
  },
  myContentStats: [CONTENT_QUERY_KEY, 'my', 'stats'],
  myTodoContent: function myTodoContent(type, page) {
    return [CONTENT_QUERY_KEY, 'my', 'todos', type, page].filter(Boolean);
  },
  mySavedContent: function mySavedContent(type, status, page) {
    return [CONTENT_QUERY_KEY, 'my', type, status, page].filter(Boolean);
  },
  mySearchContent: function mySearchContent(search, action) {
    return [CONTENT_QUERY_KEY, 'my', action, search];
  },
  myHistoryContent: function myHistoryContent(type, status, page) {
    return [CONTENT_QUERY_KEY, 'my', 'history', type, status, page].filter(Boolean);
  }
};
export default contentKeys;